import { ENDPOINTS } from "./endpoints";
import { apiFetch } from "./correlation";
import { getMintAuthHeaders } from "./mintAuth";

export async function fetchToken({
  room = "demo-room",
  identity: identityParam,
  role = "host",
}) {
  const identity =
    identityParam?.trim() ||
    `user-${Math.floor(Math.random() * 10000)}`;

  const res = await apiFetch(ENDPOINTS.TOKEN, {
    method: "POST",
    // TI-974: carry staged mint credentials when present. Fail-open — `{}`
    // when absent, and mint-auth headers never clobber existing ones.
    headers: { ...getMintAuthHeaders(), "Content-Type": "application/json" },
    body: JSON.stringify({
      room: room?.trim() || "demo-room",
      identity,
      role,
    }),
  });

  if (!res.ok) {
    const errText = await res.text();
    throw new Error(errText || `Token request failed: ${res.status}`);
  }

  const data = await res.json();

  if (!data.token || typeof data.token !== "string") {
    throw new Error("Invalid token from server");
  }

  return data.token;
}
